import { useQuery } from "@tanstack/react-query";
import React from "react";
import { BsChevronRight } from "react-icons/bs";
import { Link, useMatch, useResolvedPath } from "react-router-dom";
import { handleFetchUpcomingTrainings } from "../../api/training";

export default function Upcoming() {
  let resolved = useResolvedPath("upcoming");
  let match = useMatch({ path: resolved.pathname, end: false });

  const { data: trainings } = useQuery({
    queryKey: ["upcomingTrainings"],
    queryFn: handleFetchUpcomingTrainings,
  });
  return (
    <Link
      to="/upcoming"
      className={`border-t w-full mt-6 py-6 flex justify-between items-center px-6 hover:bg-gray-100 ${
        match ? "bg-gray-100" : ""
      }`}
    >
      <div className="flex justify-start items-center">
        <div className="text-4xl font-bold mr-2">
          {trainings?.payload?.length || 0}
        </div>
        <div className="flex flex-col">
          <div className="text-xs" style={{ fontSize: 10 }}>
            UPCOMING
          </div>
          <div className="text-xs text-gray-500" style={{ fontSize: 10 }}>
            TRAININGS
          </div>
        </div>
      </div>
      <div className="flex justify-center items-center text-xs">
        View All <BsChevronRight />
      </div>
    </Link>
  );
}
